import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/HomePage';
import ClientPortal from './servicePortal/pages/ClientPortal';
import AdminPortal from './adminPortal/pages/AdminPortal';
import InsomniaPage from './pages/InsomniaPage';
import EntPage from './pages/CRPEntPage';
import NocturnalPage from './pages/NocturnalPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/portal" element={<ClientPortal />} />
        <Route path="/admin" element={<AdminPortal />} />
        <Route path="/insomnia" element={<InsomniaPage />} />
        <Route path="/crpentertainment" element={<EntPage />} />
        <Route path="/nocturnal" element={<NocturnalPage/>} />
      </Routes>
    </Router>
  );
}

export default App;
